import { tenants } from "../../config/tenants.js";
import { slugify } from "../../utils/slugify.js";
import { CourseType } from "../CourseType.js";
import type { Locale } from "../Locale.js";
import { courseTypeNameMap } from "../names/courseTypeNameMap.js";
import { getCoursesListingPath } from "./getCoursesListingPath.js";
import { getWorkshopsPath } from "./getWorkshopsPath.js";

export function getCourseTypePath(locale: Locale, courseType: CourseType): string {
	const tenant = tenants[locale];
	if (courseType === CourseType.Workshop) {
		return getWorkshopsPath(tenant);
	}
	return `${getCoursesListingPath(tenant)}/${slugify(courseTypeNameMap[courseType][locale])}`;
}
